/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Table cells config for import subscribers limits
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import range from 'lodash/range';

import { formatNumberToPhone } from '../../../../components/common/PhoneMask/formatNumberToPhone';
import { ITableField } from '../../../../components/Table/reducers/tableReducer';
import { EColumnCell } from '../../../../components/Table/types/columnTypes';
import {
    IImportSubscribersLimitsTableStatusTranslation,
    IImportSubscribersLimitsTableTranslation,
} from '../../../../modules/internationalization/types/wizards/importSubscribersLimits';
import { IWizardImportSubscribersLimitsValidatedSubscriberResponse } from '../../types/wizardImportSubscribersLimitsTypes';
import { EImportSubscribersLimitsField } from '../../wizardImportSubscribersLimitsConstant';

export const importSubscribersLimitsColumnsWidth: { [Key in EImportSubscribersLimitsField]: number } = {
    [EImportSubscribersLimitsField.DATE]: 200,
    [EImportSubscribersLimitsField.LIMIT]: 200,
    [EImportSubscribersLimitsField.MSISDN]: 200,
    [EImportSubscribersLimitsField.STATUS]: 350,
    [EImportSubscribersLimitsField.WARNING]: 300,
};

export const importSubscribersLimitsColumnNamesIfCamEnabled: EImportSubscribersLimitsField[] = [
    EImportSubscribersLimitsField.MSISDN,
    EImportSubscribersLimitsField.LIMIT,
    EImportSubscribersLimitsField.WARNING,
    EImportSubscribersLimitsField.DATE,
    EImportSubscribersLimitsField.STATUS,
];

export const importSubscribersLimitsColumnNamesFinalStep: EImportSubscribersLimitsField[] = [
    EImportSubscribersLimitsField.MSISDN,
    EImportSubscribersLimitsField.LIMIT,
    EImportSubscribersLimitsField.WARNING,
    EImportSubscribersLimitsField.DATE,
    EImportSubscribersLimitsField.STATUS,
];

export const getColumnFilterType = (): string => {
    return '';
};

export const getColumnCellType = (name: string): string => {
    switch (name) {
        case EImportSubscribersLimitsField.STATUS:
            return EColumnCell.importSubscribersLimitsStatus;
        default:
            return EColumnCell.text;
    }
};

export const getColumnFixedType = (name: string): string | boolean => {
    switch (name) {
        // case EImportSubscribersLimitsField.ACTION:
        //     return 'right'
        default:
            return false;
    }
};

export const formImportSubscribersLimitsTableFields = (
    translation: IImportSubscribersLimitsTableTranslation,
): Array<ITableField<EImportSubscribersLimitsField>> => {
    const columnsNames: EImportSubscribersLimitsField[] = importSubscribersLimitsColumnNamesIfCamEnabled;

    return  range(columnsNames.length)
        .map(number => {
            const field = columnsNames[number];
            return {
                checked: true,
                label: translation[field],
                name: field,
                order: number,
                resizable: true,
                size: importSubscribersLimitsColumnsWidth[field],
                type: 'S',
            } as ITableField<EImportSubscribersLimitsField>
    });
}

export const formImportSubscribersLimitsTableList =
    (tableData: IWizardImportSubscribersLimitsValidatedSubscriberResponse[],
        translation: IImportSubscribersLimitsTableStatusTranslation,
    ) => {
        return  tableData.map(row => {
            const msisdn = formatNumberToPhone(row.msisdn);
            const statusErrors = !!row.errors ? row.errors.join(' ') : '';
            return {
                ...row,
                msisdn,
                status: {
                    conflictTitle: statusErrors,
                    title: statusErrors.length > 0 ? translation.error : translation.success,
                },
            }
        });
    };
